import {useEffect, useState} from 'react';
import {useClient} from '../../../context/ClientContext';
import configA from '../../../clients/HelloHealth/stepsConfig';
import configB from '../../../clients/clientB/stepsConfig';
import ClientQuestionBase from '../common/ClientQuestionBase';
import healthProfileConfig from '../../../clients/HelloHealth/healthProfileStepConfig';
import dayjs from 'dayjs';
import {SimpleLoader} from '../../loading/simpleLoader';
import {useLocation} from 'react-router-dom';

export default function MasterHealthProfilePage() {
  const {clientId} = useClient();
  const steps = clientId === 'hellohealth' ? healthProfileConfig : configB;
  const [stepIndex, setStepIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [goBackTwoSteps, setGoBackTwoSteps] = useState(false);
  const {theme} = useClient();
  const location = useLocation();
  // Default user data
  const defaultUserData = {
    gender: 'female', // Default: Female
    dateOfBirth: dayjs('1990-01-01'), // Default date
    smoker: false,
    weight: '',
    height: '',
    ethnicity: '',
    isFrontendHeightImperialUnits: false,
    isFrontendWeightImperialUnits: false,
    diabetes: '',
    isPregnant: false,
    isSmoke: false,
    isHighBP: false,
    hasHadHeartAttack: false,
    hasHadStroke: false,
    bpMeds: false,
    isHealthSymptoms: '',
    wellnessGoal: [],
    medicalCondition: [],
    allergies: [],
    isTakingSupplements: false,
    supplements: [],
    email: '',
    name: '',
    isPregnantId: '2',
    menopausalStatus: '', // Add menopausal status field
    menopausalStatusId: null, // Add menopausal status ID field
  };
  const [userData, setUserData] = useState(() => {
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      return JSON.parse(storedUserData);
    }
    return defaultUserData;
  });

  const CurrentStep = steps[stepIndex];

  const updateDataInLocalStorage = () => {
    // Check if userData exists in localStorage
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      // If userData exists, merge with new data
      const currentUserData = JSON.parse(storedUserData);
      const updatedUserData = {...currentUserData, ...userData};
      // Store merged data back to localStorage
      localStorage.setItem('userData', JSON.stringify(updatedUserData));
    } else {
      // If userData doesn't exist, store the current userData
      localStorage.setItem('userData', JSON.stringify(userData));
    }
  };

  useEffect(() => {
    const isComingFromResultPage = location.state?.flowComingFromResultPage;
    if (isComingFromResultPage) {
      setStepIndex(13);
    } else if (userData.gender === 'male') {
      //if gender is male dont show pregnant page and setIsPreganant to false
      setStepIndex(1);
      setUserData(prev => ({
        ...prev,
        isPregnant: false,
      }));
    } else {
      setStepIndex(0);
    }
  }, []);

  //checke preganenat id and update status accordingly
  useEffect(() => {
    if (userData?.isPregnantId === undefined) return;
    if (userData?.isPregnantId) {
      setUserData(prev => ({
        ...prev,
        isPregnant: userData.isPregnantId === 1 || userData.isPregnantId === 2 ? true : false,
      }));
    }
  }, [userData.isPregnantId]);

  const onNextButtonHandler = () => {
    updateDataInLocalStorage();
    setStepIndex(prev => prev + 1);
  };

  const goTwoStepsForward = () => {
    updateDataInLocalStorage();
    setStepIndex(prev => prev + 2);
  };

  const onBack = () => {
    setStepIndex(prev => Math.max(prev - (goBackTwoSteps ? 2 : 1), 0));
    setGoBackTwoSteps(false); // reset after applying
  };

  return isLoading ? (
    <SimpleLoader loadingText="Loading..." textColor={theme.primaryColor} />
  ) : (
    <ClientQuestionBase
      IsShowBackIcon={stepIndex > 0}
      backButtonHandler={onBack}
      aimdLinearBarValue={((stepIndex + 1) / steps.length) * 100}
    >
      <CurrentStep
        goTwoStepsForward={goTwoStepsForward}
        setGoBackTwoSteps={setGoBackTwoSteps}
        userData={userData}
        setUserData={setUserData}
        onNext={onNextButtonHandler}
        onBack={onBack}
        updateDataInLocalStorage={updateDataInLocalStorage}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
    </ClientQuestionBase>
  );
}
